import { useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { Box, Typography } from '@mui/material';

// icons
import { ReactComponent as CalendarIcon } from '../../assets/icons/calendar-check-icon.svg';
import { ReactComponent as EventIcon } from '../../assets/icons/event-icon.svg';

// constants
import { colors } from '../../theme';
import { MOMENT_DATE_DISPLAY_FORMAT, MOMENT_DATE_FORMAT, MOMENT_TIME_DISPLAY_FORMAT, MOMENT_TIME_FORMAT } from '../../constants/date_format';

interface DateProps {
    index: number;
}

interface TitleProps {
    isEvent: boolean;
}

const RoomSearchCard = (props: any) => {
    const { showDate, selectedRoom } = props;

    const [state, setState] = useState({
        scheduleData: [],
    });

    useEffect(() => {
        if (selectedRoom) {
            const scheduleData = [];

            const days = new Set(selectedRoom.roomSchedule.map((rs) => rs.dayOfWeek));

            days.forEach((day) => {
                const daySchedule = selectedRoom.roomSchedule.filter((rs) => rs.dayOfWeek === day);

                scheduleData.push({
                    dayOfWeek: day,
                    schedule: daySchedule,
                });
            });

            setState({
                scheduleData,
            });
        }
    }, [selectedRoom]);

    return (
        <>
            {state.scheduleData.length > 0 ? (
                state.scheduleData.map((o: any, i: any) => {
                    return (
                        <>
                            <Typography key={i} variant="body1" color={colors.grey.dark} sx={{ fontWeight: 500, mb: '5px' }}>
                                {o.dayOfWeek}
                            </Typography>
                            {o.schedule.map((card) => {
                                return (
                                    <Container>
                                        <FlexBox>
                                            <div style={{ width: '70%' }}>
                                                <FlexBox sx={{ alignItems: 'center' }}>
                                                    <div>
                                                        <Typography variant="h5" color={colors.grey.medium}>
                                                            Title
                                                        </Typography>

                                                        <TitleBox isEvent={card.isEvent}>
                                                            {card.isEvent && <EventIcon />}
                                                            {card.title}
                                                        </TitleBox>
                                                    </div>
                                                </FlexBox>
                                                <FlexBox
                                                    sx={{
                                                        mt: '15px',
                                                        alignItems: 'flex-start',
                                                        width: showDate ? '100%' : '50%',
                                                        justifyContent: 'space-between',
                                                    }}
                                                >
                                                    {showDate && (
                                                        <>
                                                            <span>
                                                                <Typography variant="h5" color={colors.grey.medium}>
                                                                    Start Date
                                                                </Typography>
                                                                <Typography>{moment(card.startDate).format(MOMENT_DATE_DISPLAY_FORMAT)}</Typography>
                                                            </span>
                                                            <span>
                                                                <Typography variant="h5" color={colors.grey.medium}>
                                                                    End Date
                                                                </Typography>
                                                                <Typography>{moment(card.endDate).format(MOMENT_DATE_DISPLAY_FORMAT)}</Typography>
                                                            </span>
                                                        </>
                                                    )}
                                                    <span>
                                                        <Typography variant="h5" color={colors.grey.medium}>
                                                            Start Time
                                                        </Typography>
                                                        <Typography>{moment(card.timeIn, MOMENT_TIME_FORMAT).format(MOMENT_TIME_DISPLAY_FORMAT)}</Typography>
                                                    </span>
                                                    <span>
                                                        <Typography variant="h5" color={colors.grey.medium}>
                                                            End Time
                                                        </Typography>
                                                        <Typography>{moment(card.timeOut, MOMENT_TIME_FORMAT).format(MOMENT_TIME_DISPLAY_FORMAT)}</Typography>
                                                    </span>
                                                </FlexBox>
                                            </div>
                                            <div
                                                style={{
                                                    borderRight: `1px solid ${colors.grey.light}`,
                                                    margin: '0px 20px',
                                                }}
                                            />
                                            <FlexBox sx={{ flexDirection: 'column', width: '20%', justifyContent: 'flex-start' }}>
                                                <Typography variant="h5" color={colors.grey.medium}>
                                                    Occupied Slots
                                                </Typography>
                                                {card.roomScheduleDetail.map((d, index) => {
                                                    return (
                                                        <DateBox index={index}>
                                                            {moment(d.date, MOMENT_DATE_FORMAT).format(MOMENT_DATE_DISPLAY_FORMAT)} {d.isConflict && <CalendarIcon />}
                                                        </DateBox>
                                                    );
                                                })}
                                            </FlexBox>
                                        </FlexBox>
                                    </Container>
                                );
                            })}
                        </>
                    );
                })
            ) : (
                <NoScheduleBox>
                    <Typography variant="body1" color={colors.grey.dark} sx={{ fontWeight: 500, mb: '5px' }}>
                        No class / event has been assigned to this room yet.
                    </Typography>
                </NoScheduleBox>
            )}
        </>
    );
};

export default RoomSearchCard;

const Container = styled.div`
    background-color: #fff;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    padding: 15px;
    margin-bottom: 10px;

    h5 {
        margin-bottom: 5px;
    }
`;

const FlexBox = styled(Box)`
    && {
        /* width: 70%; */
        display: flex;
    }
`;

const StatusBox = styled.div`
    background-color: ${colors.red.light};
    color: ${colors.red.main};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 15px;
    padding: 2px 7px;

    svg {
        margin-right: 3px;

        path {
            fill: ${colors.red.main};
        }
    }
`;

const NoScheduleBox = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const DateBox = styled.div<DateProps>`
    padding: 3px 10px;
    display: flex;
    align-items: center;
    text-align: center;
    /* justify-content: center; */
    background-color: ${(props) => (props.index % 2 ? colors.grey.light : colors.white)};
    color: ${colors.navy.main};

    svg {
        width: 16px;
        height: auto;
        margin-left: 5px;

        path {
            fill: ${colors.red.main};
        }
    }
`;

const TitleBox = styled(Typography)<TitleProps>`
    && {
        display: flex;
        align-items: center;
        background-color: ${(props) => props.isEvent && colors.yellow.light};
        svg {
            path {
                fill: ${colors.yellow.main};
            }
        }
    }
`;
